export function getFromUrl () {
  return window.location.href
}

export function handleSecurePaymentResponse (data) {
  if (data.securePaymentUrl) {
    // 3ds auth is required.
    window.location.href = data.securePaymentUrl
    return true
  } else {
    return false
  }
}
